const routeCharges = store => ({
  path: 'charges/',
  name: 'charges',
  alias: ['transactions/:id'],
  component: () =>
    import(
      /* webpackChunkName: "charges" */ '@/views/Payments/Charges/Charges.vue'
    ),
  beforeEnter: (to, from, next) => {
    if (
      !store.getters.permissionIsEnabled('charge:search') ||
      !store.getters.permissionIsEnabled('charge:get')
    ) {
      return store.commit('toggleGlobalError', { status: true, code: 404 })
    }
    next()
  },
  meta: {
    navigationBar: {
      label: 'breadcrumb.sales.charges'
    }
  }
})

const routeChargesDetail = store => ({
  path: 'charges/:id',
  name: 'chargesDetail',
  component: () =>
    import(
      /* webpackChunkName: "chargesdetail" */ '@/views/Payments/Charges/ChargesDetail.vue'
    ),
  beforeEnter: (to, from, next) => {
    if (!store.getters.permissionIsEnabled('charge:get')) {
      return store.commit('toggleGlobalError', { status: true, code: 404 })
    }
    const params = {
      chargeId: to.params.id,
      query: {
        ...to.query,
        created_at: to.query.created_at,
        is_test_account: store.getters.isTestAccount
      },
      accountId: to.params.account_id,
      merchantId: to.params.merchant_id
    }
    store.dispatch('GET_CHARGE', params).then(() => {
      next()
    })
  },
  meta: {
    navigationBar: {
      label: 'breadcrumb.sales.charges-detail',
      navigateTo: () => ({
        name: 'charges'
      })
    }
  }
})

export default [routeCharges, routeChargesDetail]
